<template lang="pug">
  div
    b-card.mb-0(no-body, :id="prevId")
      b-card-header.p-0(v-if="showHeader")
        div(v-if="header.format === 'IMAGE'")
          b-img.rounded(fluid, v-if="header.url", :src="header.url", @error="header.url = ''", style="object-fit: cover;")
          v-icon(v-else, name="image", scale="4")
        .d-flex.flex-column.align-items-center.justify-content-center.h-100(v-else-if="header.format === 'DOCUMENT'")
          v-icon(name="file", scale="2.5")
          b-link.d-block(v-if="header.url", :href="header.url" target="_blank") Documento
        div(v-else-if="header.format === 'VIDEO'")
          video.rounded(v-if="header.url", :src="header.url", controls)
          v-icon(v-else, name="video", scale="3")
      b-card-body.p-1.bg-shapes(v-else)
        b-card.overflow-y.h-100(body-class="p-1" )
          .text-sm.break-space(v-html="parseBody(bodyText)")
    b-tooltip(:target="prevId", triggers="hover", placement="right", boundary="window", variant="light", custom-class="description text-left" )
      MessageTemplatePreview(v-bind="previewData")
</template>

<script>
import MessageTemplatePreview from "@/components/MessageTemplatePreview";
export default {
  name: "WhatsappTemplatePreview",
  props: {
    prevId: {
      type: String,
      default: ''
    },
    components: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    header () {
      const header = this.components.find(el => el.type === 'HEADER') || { format: null, text: '' }
      const { example } = header
      const url = example && example.header_handle && example.header_handle.length ? header.example.header_handle[0] : ''
      return {...header, url}
    },
    bodyText () {
      const body = this.components.find(el => el.type === 'BODY')
      return body ? body.text : ''
    },
    buttons () {
      const buttons = this.components.find(el => el.type === 'BUTTONS')
      return buttons ? buttons.buttons : []
    },
    footerText () {
      const footer = this.components.find(el => el.type === 'FOOTER')
      return footer ? footer.text : ''
    },
    showHeader () {
      return this.header.format && this.header.format !== 'TEXT'
    },
    previewData () {
      return {
        header: this.header,
        defaultUrl: this.header.url,
        body_message: this.bodyText,
        footer: this.footerText,
        buttons: this.buttons
      }
    },
  },
  methods: {
    parseBody (text) {
      return text.replace(/\n/g, "<br>").replace(/\*([^*]*)\*/g, "<strong>$1</strong>")
          .replace(/_([^_]*)_/g, "<em>$1</em>")
          .replace(/~([^~]*)~/g, "<del>$1</del>")
          .replace(/```([^`]*)```/g, "<code>$1</code>")
    },
  },
  components: {MessageTemplatePreview}
}
</script>

<style lang="scss" scoped>
.card-body, .card-header, img, video {
  height: 5rem;
  width: 100%;
}
</style>

<style lang="scss">
.description > .tooltip-inner {
  min-width: 300px !important;
  max-width: 300px !important;
  font-size: 13px;
  text-align: left;
}
.bg-shapes{
  background-color: #e5ddd5 !important;
}

.bg-shapes::before {
  content: "";
  opacity: 0.1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  background: url("../assets/ilustrations/whats_bg.png") repeat;
}
</style>